export default __webpack_public_path__ + "static/media/Bing Icon.85056b99.svg";